<div class="aqa-search-page">

  <div class="aqa-search-content">
    <aside class="aqa-search-sidebar">
      <div class="aqa-search-header">
        <h1 class="page-title">Latest AQA</h1>
      </div>
      <app-aqa-search-results #aqaLatestSearchResults [resultSet]="latestAqaResults()"
                              [totCount]="latestTotalCount()"
                              [loadingComplete]="latestAqaLoading()"
                              [searched]="latestHasSearched()"
                              [page]="latestCurrentPage()"
                              [pgSize]="latestPageSize()"
                              [maxSize]="10"
                              [showSender]="true"
                              [boundaryLinks]="true">
      </app-aqa-search-results>
    </aside>

    <main class="aqa-search-main">
      <div class="aqa-search-results-container">
        <div class="aqa-search-header">
          <h1 class="page-title">Search</h1>
          <div class="searchPanel">
            <app-ai-search-bar [initialValue]="searchTerm()"
                               (search)="onSearch($event)">
            </app-ai-search-bar>

            <button class="fa-solid fa-filter filterButton" [class.displayFilter]="showFilter()" (click)="toggleFilter()">
              @if(filterSelected){
              <i class="fa-solid fa-circle"></i>
              }
            </button>
          </div>
          @if(showFilter()){
          <app-aqa-filters [activeFilters]="activeFilters()" (filtersChange)="onFiltersChange($event)" (clearFilters)="onClearFilters()"></app-aqa-filters>
          }
        </div>
        <app-aqa-search-results #aqaSearchResults [resultSet]="aqaResults()"
                                [totCount]="totalCount()"
                                [loadingComplete]="aqaLoading()"
                                [searched]="hasSearched()"
                                [page]="currentPage()"
                                [pgSize]="pageSize()"
                                [maxSize]="10"
                                [boundaryLinks]="true"
                                [needPaging]="true"
                                [showSender]="true"
                                (pageChange)="onPageChange($event)">
        </app-aqa-search-results>
      </div>

    </main>
  </div>
</div>
